// 一定要第一行，理由見檔案本身
import './zodConfig'
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import { gateReasonForRoute, requestAuthForRoute } from './composables/useAuthGate'
import { i18n, initLocale } from './i18n'
import { router } from './router'
import { installAuthBridge } from './stores/auth'
import './styles/main.scss'

/**
 * 進入點。只做組裝，沒有業務邏輯。
 *
 * 順序有意義：
 * 1. `initLocale()` 必須在 mount 前完成，否則首屏會先用預設語言渲染再閃一下
 * 2. pinia 先於 `installAuthBridge()`（它要取得 store）
 * 3. bridge 先於 router 掛載（守衛會觸發需要 token 的請求）
 */
async function bootstrap(): Promise<void> {
  await initLocale()

  const app = createApp(App)

  app.use(createPinia())
  app.use(i18n)

  /**
   * 把 auth store 接到 HTTP 層，讓 401 能自動觸發 refresh。
   *
   * session 徹底失效時**不換頁**，就地開登入對話框並記住現在這一頁 ——
   * 使用者什麼都沒做（是 refresh token 到期了），把他的畫面換掉是我們
   * 單方面打斷他。登入完成後 `resume()` 會發現目的地就是現在這一頁，
   * 於是什麼都不做，他繼續看原本在看的東西。
   */
  installAuthBridge(() => {
    const current = router.currentRoute.value
    if (current.name === 'login') return

    requestAuthForRoute(gateReasonForRoute(String(current.name ?? '')), current.fullPath)
  })

  app.use(router)
  app.mount('#app')
}

void bootstrap()
